import { createApi } from '@reduxjs/toolkit/query/react';
import type { BidHistoryApiResponse } from 'tradera/state/services/types/webapi-shopping-generated';
import { isomorphicWebApiBaseQuery } from 'tradera/state/services/utils/webapi-base-query';

export const bidHistoryApi = createApi({
    reducerPath: 'bidHistoryApi',
    baseQuery: isomorphicWebApiBaseQuery,
    endpoints: (builder) => ({
        getBidHistory: builder.query<BidHistoryApiResponse, number>({
            query: (itemId) => {
                return `/shopping/bidhistory/${itemId}`;
            }
        })
    })
});

export const { useGetBidHistoryQuery } = bidHistoryApi;
